var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('memlist-modal',{ref:"edit-form",attrs:{"size":"lg","visible":_vm.showModal,"hide-footer":""},on:{"close":_vm.closing}},[_c('DonateraWidgetContent',{attrs:{"linkstr":_vm.linkstr,"form":_vm.form}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }